import { createContext, useContext, useMemo, useState } from 'react';

interface BreadcrumbContextType {
  lastItemOverride?: string;
  setLastItemOverride: (override?: string) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | null>(null);

export const useBreadcrumbOverride = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error(
      'useBreadcrumbOverride must be used within BreadcrumbProvider'
    );
  }
  return context;
};

const BreadcrumbProvider = ({ children }: { children: React.ReactNode }) => {
  const [lastItemOverride, setLastItemOverride] = useState<string>();

  const value = useMemo(
    () => ({
      lastItemOverride,
      setLastItemOverride,
    }),
    [lastItemOverride]
  );

  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
};

export default BreadcrumbProvider;
